module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "1rg9jc9j",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
    token:
      process.env.SANITY_TOKEN ||
      "skCKakA6Wc6hD5njmZ0e3a0WkhIJDPJT64fELNVZ9MS5QlUuAR0QUXvfuu0OJfiQIJEj9BqohgKp1Vy5bg52Rg3EIhfzmGh4yCALDB73e0pK2HIz9NJ6TX47yl29gaS9jSAKkRQHoL6mSZuTLXT6mxHFO2wvRY5iAq5I2sNjfikLdy1KYlNd",
  },
}
